const data: any = {
  func: {
    apiHost: "//joshome.jd.com",
    moreProposalPlaceholder:
      "请详细描述您在使用文档中遇到的问题。例如：在使用接口过程中出参pin字段实际返回值与字段描述不符，无法使用。",
    proposalList: [
      { value: "接口使用场景不清晰" },
      { value: "接口示例或描述不清晰" },
      { value: "出入参结果和文档描述不一致" },
      { value: "无错误码和解决方案，报错无法解决" },
      { value: "接口设计逻辑有误，不符合业务场景" },
      { value: "无" },
    ],
    loginHost: "https://passport.jd.com/new/login.aspx",
  },
  style: {},
  data: {},
  _clstag_: "jdzeus_apilist_zeus_api_list",
};
export default data;
